import { SubjectManagement } from './SubjectManagement'

export default function Subject({}: { onBack?: () => void }) {
  return <SubjectManagement />
}
